/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  FontSizes,
  IStackItemStyles,
  IStackStyles,
  ITextFieldStyles,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

export const wrapperStyles: IStackStyles = {
  root: {
    border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
    borderRadius: "0.5rem",
    padding: "2.25rem 1.5rem",
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.2)",
    marginTop: "1.5rem",
  },
};

export const titleStyles: IStackItemStyles = {
  root: {
    padding: "1.5rem",
    background: theme.palette.neutralLight,
    borderRadius: "0.5rem",
  },
};

export const titleTextStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.size20,
    fontWeight: 600,
  },
};

export const messageStackStyles: IStackItemStyles = {
  root: { alignSelf: "center" },
};

export const formStackStyles: IStackStyles = {
  root: {
    padding: "1rem 1rem 1rem 0",
    justifyContent: "space-between",
  },
};

export const textFieldStackStyles: IStackStyles = {
  root: {
    width: "70%",
  },
};

export const textStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.size16,
  },
};

export const errorMessageStyles: ITextStyles = {
  root: {
    color: theme.palette.red,
  },
};

export const textFieldStyles: Partial<ITextFieldStyles> = {
  fieldGroup: {
    borderRadius: "0.5rem",
    borderColor: theme.palette.neutralTertiary,
    minHeight: "7rem",
  },
};
